<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">{{ $t('parttypes.title') }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <search @make_search="make_search"/>
                <table class="table table-striped dataTable my-4 w-100" id="parttypes">
                  <thead>
                  <tr>
                    <th
                      :class="{
                          'sorting_asc': ordering === 'name',
                          'sorting_desc': ordering === '-name'}"
                      @click="order('name')">{{ $t('parttypes.group') }}
                    </th>
                    <th>{{ $t('parttypes.category') }}</th>
                    <th
                      :class="{
                          'sorting_asc': ordering === 'is_active',
                          'sorting_desc': ordering === '-is_active'}"
                      @click="order('is_active')">{{ $t('parttypes.state') }}
                    </th>
                    <th class="wd-xs"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="row.id" class="gradeX" v-for="row in rows">
                    <td>{{ row.name }}</td>
                    <td>{{ row.category_name }}</td>
                    <td>{{ row.is_active ? 'Active' : 'Disabled' }}</td>
                    <td>
                      <div class="btn-group">
                        <router-link
                          :to="{name: 'parttype_edit', params: {id: row.id}}"
                          :title="$t('parttypes.button-edit')"
                          class="far fa-edit btn btn-link link-unstyled px-1 py-2 text-info">
                        </router-link>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <pagination
                  :page="page"
                  :pages="pages"
                  :count="count"
                  :from="(page - 1) * page_size + 1"
                  :to="(page - 1) * page_size + rows.length"
                  @paginate="paginate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Contentheading from '@/components/Contentheading.vue'
import message from '@/message'
import Pagination from '@/components/Pagination.vue'
import Search from '@/components/Search.vue'

const getData = (route, next) => {
  const search = route.query.search
  const ordering = route.query.ordering || 'name'
  const page = parseInt(route.query.page) || 1

  let stored_page_size = JSON.parse(localStorage.getItem('etend.page_size'))
    || {}
  let page_size = route.query.page_size
    || stored_page_size[route.name]
    || process.env.DEFAULT_PAGE_SIZE

  api.get('/part_types/', {
    params: {
      search: search,
      ordering: ordering,
      page: page,
      page_size: page_size
    }
  })
    .then(resp => {
      next({
        rows: resp.data.results,
        search: search,
        ordering: ordering,
        pages: resp.data.pages,
        count: resp.data.count,
        page: page,
        page_size: page_size
      })
    })
}

export default {
  components: {
    contentheading: Contentheading,
    pagination: Pagination,
    search: Search
  },
  data() {
    return {
      rows: [],
      search: null,
      ordering: null,
      pages: null,
      count: null,
      page: null,
      page_size: null
    }
  },
  computed: {
    is_supplier() {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted() {
    this.$parent.menu = 'setup'
    this.$parent.submenu = 'parttypes'
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    order(o) {
      this.$parent.order(o, this.search, this.ordering)
    },
    paginate(p) {
      this.$parent.paginate(p, this.search, this.ordering)
    },
    make_search() {
      this.$parent.make_search(this.search, this.ordering)
    }
  },
  beforeRouteEnter(to, from, next) {
    getData(to, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate(to, from, next) {
    getData(to, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Parttypes.vue